<template>
  <div>
    <div class="text-lg font-bold text-text leading-tight mb-4">
      <template v-if="datePassed">
        <font-awesome-icon icon="exclamation-triangle"
                           class="text-yellow mr-2"/>
        {{ $t('notApproved') }}
      </template>
      <template v-else>
        {{ $t('planned') }}
      </template>
    </div>
    <div v-if="loading" class="flex justify-center">
      <font-awesome-icon class="text-center text-lg text-primary" icon="circle-notch" spin/>
    </div>
    <template v-else>
      <div>
        <PlannedTransactionItem v-for="(transaction,i) in notConfirmedTransactions" :key="i"
                                :transaction="transaction"
                                :apply-opacity="true"
                                @edit="startEditTransaction(transaction)"
                                @confirm="confirmEvent"
                                layout="calendar"/>
      </div>
      <div class="mt-2"
           v-show="current_page < pages_length || more_loading">
                <span v-if="!more_loading"
                      class="text-2sm text-text-ternary cursor-pointer mt-8
                      transition duration-200
                      border-b border-dashed border-text-ternary
                      hover:text-red hover:border-red"
                      @click="showMore">{{ $t('showMore') }}</span>
        <font-awesome-icon v-else class="text-primary" icon="circle-notch" spin/>
      </div>
    </template>
    <PlannedTransactionEditModal position="absolute"
                                 :template="editTemplate"
                                 @close="editTemplate = null"
                                 @success="updateCalendarData"/>
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import TransactionItem from "@/components/common/Transaction/TransactionItem/TransactionItem";
import PlannedTransactionItem
  from "@/components/common/PlannedTransaction/PlannedTransactionItem/PlannedTransactionItem";
import PlannedTransactionEditModal
  from "@/components/common/PlannedTransaction/PlannedTransactionEditModal/PlannedTransactionEditModal";

export default {
  name: "CalendarInfoPlannedTransactions",
  components: {PlannedTransactionEditModal, PlannedTransactionItem, TransactionItem},
  data() {
    return {
      editTemplate: null
    }
  },
  computed: {
    ...mapState('space/calendar', {
      date: state => state.dateSelected,
      plannedTransactions: state => state.datePlannedTransactions.data,
      loading: state => state.datePlannedTransactions.dirty,
      more_loading: state => state.datePlannedTransactions.moreLoading,
      current_page: state => state.datePlannedTransactions.pagination.current_page,
      pages_length: state => state.datePlannedTransactions.pagination.pages
    }),
    datePassed() {
      return this.$moment(this.date, 'YYYY-MM-DD').diff(this.$moment().startOf('day'), 'days') < 0;
    },
    notConfirmedTransactions() {
      //todo перенести на бэк
      return this.plannedTransactions.filter(item => !item.transaction_id)
    }
  },
  methods: {
    ...mapActions('space/calendar', [
      'fetchCalendar',
      'fetchTransactions',
      'fetchPlannedTransactions',
      'fetchMorePlannedTransactions',
      'confirmPlannedTransaction']),
    ...mapMutations('space/calendar', ['setPlannedTransactionsPage', 'clearPlannedTransactions']),
    async showMore() {
      this.setPlannedTransactionsPage(this.current_page + 1)
      try {
        await this.fetchMorePlannedTransactions();
      } catch (err) {
        console.error(err)
      }
    },
    async confirmEvent(id) {
      try {
        const res = await this.confirmPlannedTransaction(id)
        if (res.body.success) {
          this.$toasted.success(this.$t('transactionConfirmed'));
          this.updateCalendarData();
        } else {
          this.$toasted.error(this.$t('errors.response'));
          console.log(res)
        }
      } catch (err) {
        this.$toasted.error(this.$t('errors.response'));
        console.error(err)
      }
    },
    startEditTransaction(transaction) {
      this.editTemplate = {
        ...transaction.template,
        next_event_at: transaction.date
      }
    },
    updateCalendarData() {
      this.fetchCalendar();
      this.fetchTransactions();
      this.fetchPlannedTransactions();
    }
  },
  watch: {
    date: {
      immediate: true,
      handler(newVal) {
        this.clearPlannedTransactions();
        if (newVal) {
          this.fetchPlannedTransactions();
        }
      }
    }
  },
  i18n: {
    messages: {
      en: {
        planned: 'Scheduled',
        notApproved: 'Not approved',
        showMore: 'Show more',
        transactionConfirmed: 'Transaction confirmed'
      },
      ru: {
        planned: 'Запланировано',
        notApproved: 'Не подтверждено',
        showMore: 'Показать ещё',
        transactionConfirmed: 'Транзакция подтверждена'
      }
    },
  }
}
</script>